var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-select',_vm._b({on:{"change":_vm.triggerChange}},'a-select',_vm.$props,false),[_vm._l((_vm.list),function(item){return [_c('a-select-option',{key:item.role_id,attrs:{"value":item.role_id}},[_vm._v(_vm._s(item.name))])]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }